import { AppleIcon, FacebookIcon, GoogleIcon } from '@authentic/loyalty-pwa/icons';
import { UserOAuthMethods, UserSignupMethods } from '@authentic/loyalty-pwa/interfaces';
import { breakpoints, colors } from '@authentic/loyalty-pwa/util/variables';
import { h } from 'preact';
import styled from 'styled-components';
import { oauthServices } from '../lib/OAuthServices';

const SocialButtonWrapper = styled.div`
  @media screen and (min-width: ${breakpoints.sm}) {
    display: flex;
    justify-content: center;
  }
`;

const SocialButton = styled.div`
  border: 1px solid ${colors.gray1};
  border-radius: 1.25em;
  cursor: pointer;
  margin: 21px 0;
  padding: 10px 0;
  height: 43px;
  max-height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    width: 18px;

    svg {
      display: block;
      height: auto;
      max-width: 100%;
      width: 100%;
    }
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    line-height: 20px;
    margin: 20px 10px 40px;
    width: 140px;
  }
`;

export const SocialButtons = () => {
  const login = (provider: UserOAuthMethods) => {
    // Could just return the function itself but that leads to scope issues
    return oauthServices[provider].login.bind(oauthServices[provider])
  }

  return (
    <SocialButtonWrapper>
      <SocialButton onClick={login(UserSignupMethods.FACEBOOK)}>
        <div className="icon">
          <FacebookIcon />
        </div>
        Facebook
      </SocialButton>
      <SocialButton onClick={login(UserSignupMethods.GOOGLE)}>
        <div className="icon">
          <GoogleIcon />
        </div>
        Google
      </SocialButton>
      <SocialButton onClick={login(UserSignupMethods.APPLE)}>
        <div className="icon">
          <AppleIcon />
        </div>
        Apple
      </SocialButton>
    </SocialButtonWrapper>
  );
};
